import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { RegisterComponent } from '../../Components/Home/register/register';
import { ProductSelectionService } from '../../Shared/product-selection/product-selection.service';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-register-page',
  standalone: true,
  imports: [CommonModule, RegisterComponent],
  templateUrl: './register-page.html',
})
export class RegisterPageComponent implements OnInit {
  private router = inject(Router);
  private seo = inject(SeoService);
  productSelection = inject(ProductSelectionService);

  ngOnInit(): void {
    if (!this.productSelection.selectedApps.length) {
      this.router.navigate(['/product']);
      return;
    }

    this.seo.update({
      title: 'Create Your Account',
      description: 'Finish setting up your orderYaa ERP workspace — free, with unlimited users, no credit card required.',
      path: '/register',
    });
  }

  goBack(): void {
    this.router.navigate(['/product']);
  }
}
